import styles from "../styles/Header.module.css";

export default function Header({ children, title, subtitle }) {
  return (
    <section>
      <div className={styles.top}>
        <div className={styles.inner}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.subhead}>{subtitle}</p>
          {children}
        </div>
      </div>

      <div className={styles.spacer} aria-hidden="true" />
    </section>
  );
}
